import { useEffect } from 'react';
import { HubConnectionBuilder } from '@microsoft/signalr';

import { getAccessToken } from '@/api/auth';
import { getEmsServerUrl } from '@/api/baseUrls';
import { useNavigateToLogout } from '@/app/auth/interactiveLogout';

export function ForceLogoutWatcher() {
  const navigateToLogout = useNavigateToLogout();

  useEffect(() => {
    const connection = new HubConnectionBuilder()
      .withUrl(new URL('/hub/logout', getEmsServerUrl()).toString(), {
        accessTokenFactory: async () => (await getAccessToken()) ?? '',
      })
      .withAutomaticReconnect()
      .build();

    connection.on('ForceLogout', () => {
      navigateToLogout();
    });

    let cancelled = false;
    let retryTimer: ReturnType<typeof setTimeout> | undefined;

    const startWithRetry = (attempt: number) => {
      connection.start().catch((error: unknown) => {
        console.error('[SLO] Logout hub connection failed', error);
        if (cancelled) {
          return;
        }
        const delayMs = Math.min(30000, 1000 * 2 ** attempt);
        retryTimer = setTimeout(() => startWithRetry(attempt + 1), delayMs);
      });
    };
    startWithRetry(0);

    return () => {
      cancelled = true;
      if (retryTimer != null) {
        clearTimeout(retryTimer);
      }
      void connection.stop();
    };
  }, [navigateToLogout]);

  return null;
}
